import { mapState } from 'vuex'
import errorMessages from '@/helpers/errorMessages.js'

export default {
  computed: {
    ...mapState('app', ['errorCode']),
    errorMessage: function () {
      return errorMessages[this.errorCode]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/error-page/error-page.js